"use client";

import { Loader2 } from "lucide-react";
import { useFormStatus } from "react-dom";
import { buttonVariants } from "@/components/ui/button-variants";
import { cn } from "@/lib/utils";

export default function ToolPathSubmitButton({
  submitLabel,
  loadingLabel,
}: {
  submitLabel: string;
  loadingLabel: string;
}) {
  const { pending } = useFormStatus();

  return (
    <button
      type="submit"
      disabled={pending}
      aria-busy={pending}
      aria-label={pending ? loadingLabel : undefined}
      className={cn(
        buttonVariants({ size: "lg" }),
        "grid h-12 w-full shrink-0 place-items-center px-8 sm:w-auto",
      )}
    >
      <span
        className={cn("col-start-1 row-start-1", pending && "invisible")}
      >
        {submitLabel}
      </span>
      {pending ? (
        <Loader2
          className="col-start-1 row-start-1 size-5 animate-spin"
          aria-hidden="true"
        />
      ) : null}
    </button>
  );
}
